<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { mapActions, mapGetters } from "vuex";
import { required, requiredIf, minLength, maxLength, url } from "vuelidate/lib/validators";
import {swal} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error'
import Link from '../../../model/link.js';
import { VueContentLoading } from 'vue-content-loading';

export default {
  page: {
    title: "الخدمات",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect, AlertError, VueContentLoading},
  data() {
    return {
     
      title: "تعديل الخدمة",
      items: [
        {
          text: "الخدمات",
          href: "/links",
        },
        {
          text: "تعديل الخدمة",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      link: new Link(undefined),

      submitadd: false,
      loadingButton: false,
      loadingContent: false 
    };
  },
  validations: {
     link: {
      title_ar: {required: requiredIf(function (){ return this.checkLocale('ar'); }), minLength: minLength(2), maxLength: maxLength(300) },
      title_en: {required: requiredIf(function (){ return this.checkLocale('en'); }), minLength: minLength(2), maxLength: maxLength(300) },
      title_fa: {required: requiredIf(function (){ return this.checkLocale('fa'); }), minLength: minLength(2), maxLength: maxLength(300) },
      url_ar: {required: requiredIf(function (){ return this.checkLocale('ar'); }), url, maxLength: maxLength(500) },
      url_en: {required: requiredIf(function (){ return this.checkLocale('en'); }), url, maxLength: maxLength(500) },
      url_fa: {required: requiredIf(function (){ return this.checkLocale('fa'); }), url, maxLength: maxLength(500) },
      icon: {required, maxLength: maxLength(50)},
      locations: {required},
      locales: {required},
    },
  },
  computed:{
    ...mapGetters('location', { locations: 'getLocations' }),
    ...mapGetters('link', ['getLink' ])
  },
  methods: {
    ...mapActions("link", ['get', 'edit']),
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    checkLocale(locale){
      return this.link.locales.includes(locale);
    },
    checkValidate(){
      return !this.$v.link.locales.$error &&
        (!this.checkLocale('ar') || !this.$v.link.title_ar.$error) && 
        (!this.checkLocale('en') || !this.$v.link.title_en.$error) && 
        (!this.checkLocale('fa') || !this.$v.link.title_fa.$error) &&
        (!this.checkLocale('ar') || !this.$v.link.url_ar.$error) &&
        (!this.checkLocale('en') || !this.$v.link.url_en.$error) &&
        (!this.checkLocale('fa') || !this.$v.link.url_fa.$error) &&
        !this.$v.link.icon.$error &&
        !this.$v.link.locations.$error
    },
    formEditLink(published = false) {
      this.submitadd = true;
      this.$v.$touch();
      if(!this.checkValidate()) return;

      // to form submit after this
      this.loadingButton = true
      this.errors = [];
      
      this.link.published = published

      this.edit({
        id: this.id,
        link: this.link.toFormData()
      })
      .then((response)=>{
        swal.success(response.data.message)
        this.loadingButton = false
      })
      .catch((error)=>{
        this.handleError(error)
        this.loadingButton = false
      })
    }
  },
  created(){
    this.get(this.id)
    .then(()=>{
      this.link = this.getLink
      this.loadingContent = true
    })
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">

      <div class="col-md-12">
        <div class="card">
          <div class="card-body">

            <b-form v-if="loadingContent">

              <AlertError :errors="errors"></AlertError>

             <div class="row mt-3">

                <b-form-group class="col-md-12 mb-3" label="لغة الخدمة :">
                  <b-form-checkbox class="dis-inline" v-model="link.locales" value="ar" plain>عربي</b-form-checkbox>
                  <b-form-checkbox class="dis-inline" v-model="link.locales" value="en" plain>انكليزي</b-form-checkbox>
                  <!-- <b-form-checkbox class="dis-inline" v-model="link.locales" value="fa" plain>فارسي</b-form-checkbox> -->
                  <div v-if="submitadd && $v.link.locales.$error" class="invalid-check">
                    <span v-if="!$v.link.locales.required"> يجب اختيار لغة واحدة على الاقل </span>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-6 mb-3" label="شعار الخدمة : " label-for="icon" >
                  <div class="input-group">
                    <b-form-input id="icon" v-model="link.icon" :class="{ 'is-invalid': submitadd && $v.link.icon.$error}" placeholder="مثال : fa fa-user" type="text" ></b-form-input>
                    <a href="https://fontawesome.com/v4.7/icons/" target="_blank"><button class="btn btn-primary" type="button">اختر شعار</button></a>
                    <div v-if="submitadd && $v.link.icon.$error" class="invalid-feedback">
                      <span v-if="!$v.link.icon.required"> هذا الحقل الزامي </span>
                      <span v-if="!$v.link.icon.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 10 احرف على الاقل . </span>
                      <span v-if="!$v.link.icon.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 100 حرف على الاكثر . </span>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-6 mb-3" label="مكان عرض الخدمة :" label-for="locations" >
                  <multiselect 
                    id="locations" 
                    select-label="اختر المكان"
                    placeholder="اختر المكان"
                    deselect-label="اظغط هنا لمسح الاختيار"
                    selected-label="تم اختياره"
                    :class="{ 'is-invalid': submitadd && $v.link.locations.$error }"
                    v-model="link.locations"
                    :options="locations"
                    track-by="id"
                    label="Title"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :multiple="true">
                  </multiselect>
                  <div v-if="submitadd && $v.link.locations.$error" class="invalid-feedback">
                    <span v-if="!$v.link.locations.required"> هذا الحقل الزامي </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="checkLocale('ar')" class="col-md-12 mb-3 class_ar" label="عنوان الخدمة : ( عربي )" label-for="title_ar" >
                  <b-form-input id="title_ar" v-model.trim="link.title_ar" :class="{ 'is-invalid': submitadd && $v.link.title_ar.$error }" placeholder="ادخل عنوان الخدمة" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.link.title_ar.$error" class="invalid-feedback">
                    <span v-if="!$v.link.title_ar.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.link.title_ar.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.link.title_ar.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="checkLocale('ar')" class="col-md-12 mb-3 class_ar" label="رابط الخدمة : ( عربي )" label-for="url_ar" >
                  <b-form-input id="url_ar" v-model.trim="link.url_ar" :class="{ 'is-invalid': submitadd && $v.link.url_ar.$error }" placeholder="ادخل رابط الخدمة" type="url" ></b-form-input>
                  <div v-if="submitadd && $v.link.url_ar.$error" class="invalid-feedback">
                    <span v-if="!$v.link.url_ar.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.link.url_ar.url"> يجب أن تكون هذه القيمة عنوان url صالحًا. </span>
                    <span v-if="!$v.link.url_ar.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 500 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="checkLocale('ar')" class="col-md-12 mb-3 class_ar" label="وصف الخدمة : ( عربي )" label-for="description_ar" >
                  <textarea id="description_ar" v-model="link.description_ar" class="form-control" rows="5" ></textarea>
                </b-form-group>

                <b-form-group v-if="checkLocale('en')" class="col-md-12 mb-3 class_en" label="عنوان الخدمة : ( انجليزي )" label-for="title-en" >
                  <b-form-input id="title-en" v-model.trim="link.title_en" :class="{ 'is-invalid': submitadd && $v.link.title_en.$error }" placeholder="ادخل عنوان الخدمة" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.link.title_en.$error" class="invalid-feedback">
                    <span v-if="!$v.link.title_en.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.link.title_en.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.link.title_en.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="checkLocale('en')" class="col-md-12 mb-3 class_en" label="رابط الخدمة : ( انجليزي )" label-for="url_en" >
                  <b-form-input id="url_en" v-model.trim="link.url_en" :class="{ 'is-invalid': submitadd && $v.link.url_en.$error }" placeholder="ادخل رابط الخدمة" type="url" ></b-form-input>
                  <div v-if="submitadd && $v.link.url_en.$error" class="invalid-feedback">
                    <span v-if="!$v.link.url_en.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.link.url_en.url"> يجب أن تكون هذه القيمة عنوان url صالحًا. </span>
                    <span v-if="!$v.link.url_en.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 500 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="checkLocale('en')" class="col-md-12 mb-3 class_en" label="وصف الخدمة : ( انجليزي )" label-for="description_en" >
                  <textarea id="description_en" v-model="link.description_en" class="form-control" rows="5" ></textarea>
                </b-form-group>

                <b-form-group v-if="checkLocale('fa')" class="col-md-12 mb-3 class_fa" label="عنوان الخدمة : ( فارسي )" label-for="title-fa" >
                  <b-form-input id="title-fa" v-model.trim="link.title_fa" :class="{ 'is-invalid': submitadd && $v.link.title_fa.$error }" placeholder="ادخل عنوان الخدمة" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.link.title_fa.$error" class="invalid-feedback">
                    <span v-if="!$v.link.title_fa.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.link.title_fa.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.link.title_fa.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="checkLocale('fa')" class="col-md-12 mb-3 class_fa" label="رابط الخدمة : ( فارسي )" label-for="url_fa" >
                  <b-form-input id="url_fa" v-model.trim="link.url_fa" :class="{ 'is-invalid': submitadd && $v.link.url_fa.$error }" placeholder="ادخل رابط الخدمة" type="url" ></b-form-input>
                  <div v-if="submitadd && $v.link.url_fa.$error" class="invalid-feedback">
                    <span v-if="!$v.link.url_fa.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.link.url_fa.url"> يجب أن تكون هذه القيمة عنوان url صالحًا. </span>
                    <span v-if="!$v.link.url_fa.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 500 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="checkLocale('fa')" class="col-md-12 mb-3 class_fa" label="وصف الخدمة : ( فارسي )" label-for="description_fa" >
                  <textarea id="description_fa" v-model="link.description_fa" class="form-control" rows="5" ></textarea>
                </b-form-group>

              </div>


              <div class="mt-3">
                <hr>
                <b-button :disabled="loadingButton" @click="formEditLink(false)" variant="primary" type="button" class="me-2"> 
                  <b-spinner v-if="loadingButton && !link.published" small></b-spinner>
                  <span v-else><i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</span>
                </b-button>

                <b-button :disabled="loadingButton" @click="formEditLink(true)" variant="success" type="button"> 
                  <b-spinner v-if="loadingButton && link.published" small></b-spinner>
                  <span v-else><i class="bx bx-paper-plane font-size-16 align-middle me-2"></i>نشر</span>
                </b-button>

                <b-button class="f-left" type="button" to="/links" variant="secondary">رجوع</b-button>
              </div>

            </b-form>
            
             <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="310">
                <rect x="0" y="4" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="8" rx="1" ry="1" width="4" height="4" />
                <rect x="6" y="10" rx="1" ry="1" width="10" height="1" />
                <rect x="20" y="08" rx="1" ry="1" width="4" height="4" />
                <rect x="26" y="10" rx="1" ry="1" width="10" height="1" />
                <rect x="40" y="8" rx="1" ry="1" width="4" height="4" />
                <rect x="46" y="10" rx="1" ry="1" width="10" height="1" />

                <rect x="0" y="18" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="22" rx="1" ry="1" width="176" height="10" />
                <rect x="177" y="22" rx="1" ry="1" width="20" height="10" />
                <rect x="203" y="18" rx="1" ry="1" width="50" height="2" />
                <rect x="203" y="22" rx="1" ry="1" width="197" height="10" />

                <rect x="0" y="37" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="41" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="56" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="60" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="75" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="79" rx="1" ry="1" width="400" height="35" />

                <rect x="0" y="119" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="123" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="138" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="142" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="157" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="161" rx="1" ry="1" width="400" height="35" />

                <rect x="0" y="201" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="205" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="220" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="224" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="239" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="243" rx="1" ry="1" width="400" height="35" />

                <rect x="0" y="286" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="291" rx="1" ry="1" width="20" height="10" />
                <rect x="22" y="291" rx="1" ry="1" width="20" height="10" />
                <rect x="385" y="291" rx="1" ry="1" width="15" height="10" />
              </vue-content-loading>
            </div>

          </div>
        </div>
      </div>
                    
    </div>
    
  </Layout>
</template>